import {useState} from 'react'
import {useTranslation} from 'react-i18next'
import {Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle} from '@/components/ui/dialog'
import {HelpIcon} from '@/components/help-icon'
import {FichaDatosGenerales} from '@/components/bateria/ficha-datos-generales'
import {type BateriaPaquete} from '@/hooks/bateria/use-bateria'

/** La ficha desde cualquier fila, sea cual sea el estado: la sección de revisión solo existe para
 * transcritos con dudosos. */
export function FichaDialog({
  businessId,
  evaluacionId,
  paquete,
  open,
  onOpenChange,
}: {
  businessId: string
  evaluacionId: string
  paquete: BateriaPaquete
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const {t} = useTranslation()
  // Ref de callback: Radix monta el contenido del diálogo después del primer efecto (ver `popover.tsx`).
  const [nodo, setNodo] = useState<HTMLElement | null>(null)
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent ref={setNodo} className="max-w-3xl" data-testid="ficha-dialog">
        <DialogHeader>
          <DialogTitle className="inline-flex items-center gap-1.5">
            {t('admin.bateria.ficha.title')}
            <HelpIcon
              label={t('common.help.iconLabelFor', {campo: t('admin.bateria.ficha.title')})}
              testId="ficha-tip"
              contenedor={nodo}>
              {t('admin.bateria.ficha.tip')}
            </HelpIcon>
          </DialogTitle>
          <DialogDescription>
            {paquete.employee_name} · {t('admin.bateria.formaValue', {forma: paquete.forma})}
          </DialogDescription>
        </DialogHeader>
        <div className="max-h-[70vh] overflow-y-auto pr-1">
          <FichaDatosGenerales
            businessId={businessId}
            evaluacionId={evaluacionId}
            paqueteId={paquete.id}
            enabled={open}
            onSaved={() => onOpenChange(false)}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}
